interface Props {
  status: string
}

const StatusCell: React.FC<Props> = ({ status }) => {
  const findStatus = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'planning':
        return 'Planning'
      case 'pending':
        return 'รอเปิดงาน'
      case 'in-progress':
        return 'กำลังดำเนินการ'
      case 'in progress':
        return 'กำลังดำเนินการ'
      case 'hold':
        return 'หยุดพัก'
      case 'cancel':
        return 'ยกเลิกโครงการ'
      case 'completed':
        return 'เสร็จสิ้น'
      default:
        return ''
    }
  }

  const findColor = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'in-progress':
        return 'badge-primary'
      case 'in progress':
        return 'badge-primary'
      case 'hold':
        return 'badge-warning'
      case 'cancel':
        return 'badge-danger'
      case 'completed':
        return 'badge-success'
      default:
        return 'badge-warning'
    }
  }

  return (
    <>
      {status && status.toLowerCase() !== '' ? (
        <span className={`badge ${findColor(status)}`}>{findStatus(status)}</span>
      ) : (
        '-'
      )}
    </>
  )
}

export default StatusCell
